import isEqual from 'lodash/isEqual';
import { useSelector } from 'react-redux';

export const useDeepSelector = <TState = unknown, TSelected = unknown>(
    selector: (state: TState) => TSelected,
): TSelected => useSelector(selector, isEqual);
